<p class="intro-text">
    <em [innerHTML]="'researcherDeposit.dialog.intro' | translate"></em>
</p>

<esp-deposit-form-section [sectionTitle]="'researcherDeposit.dialog.type.header' | translate" [required]="true">
    <esp-deposit-type
        (typeSelected)="onTypeSelection($event)"
        (clearSelection)="isTypeSelected.set(false)"
    ></esp-deposit-type>
</esp-deposit-form-section>

@if (isTypeSelected() && displaySearchFor()) {
    <esp-deposit-form-section
        [sectionTitle]="getSearchForTitle() | customTranslate"
        [description]="getSearchForDescription() | customTranslate"
    >
        @if (selectedResearch()) {
            <esp-deposit-selected-research
                [research]="selectedResearch()"
                (removeSelected)="onRemoveSelectedWork()"
                [@growInAnimation]="{ value: ':enter', params: { time: '0.7s' } }"
                [@growOutAnimation]="{ value: ':enter', params: { time: '0.7s' } }"
            >
            </esp-deposit-selected-research>
        } @else {
            <esp-deposit-search-for
                (selectedResearch)="onResearchSelection($event)"
                [userId]="userId"
                @growInAnimation
                @growOutAnimation
                [label]="'research.search.overline' | customTranslate"
                [updateFormData]="true"
            >
            </esp-deposit-search-for>
        }
    </esp-deposit-form-section>
}

<esp-deposit-form-section [sectionTitle]="'researcherDeposit.dialog.files.header' | translate">
    <esp-deposit-files-links [multiple]="true"></esp-deposit-files-links>
</esp-deposit-form-section>
<button
    [disabled]="!isTypeSelected()"
    [gleam]="false"
    [jellyOnHover]="false"
    mulo-funky-button
    (click)="handleContinue()"
>
    @if (autoPopInProgress()) {
        <mat-spinner
            [matTooltip]="'researcherDeposit.dialog.autoPop.tooltip' | translate"
            class="margin-right-xs"
            diameter="24"
        ></mat-spinner>
    }
    <span class="margin-right-xs"> {{ 'researcherDeposit.dialog.continue' | translate }}</span>
    <mat-icon class="mat-icon-rtl-mirror" svgIcon="send"></mat-icon>
</button>
